// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#stawag-leads-form .gc-multiple-choice .row{margin-top:0;margin-bottom:0}#stawag-leads-form .gc-multiple-choice .v-text-field__details{display:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
